import { createSlice } from '@reduxjs/toolkit';

const initialStateValue =  [
  { 
    id : 1,
    to : 'marina', 
    title: '마리나시설', 
  },
  { 
    id : 2,
    to : 'product',
    title: '제품소개',
  },
  {
    id : 3,
    to : 'company', 
    title: '회사소개',
  }
];
 
const getHeaderTitleSlice = createSlice({
  name:'headerTitleSlice',
  initialState: {value : initialStateValue},
  reducers:{
    
    }
});



export default getHeaderTitleSlice;